// Copyright (c) 2016 Deere & Company

import './report-criteria-footer.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {showRequired} from './required';

const ReportCriteriaFooter = props =>
    <section className='report-criteria-footer'>
        {showRequired(props)}
        <div className='button-group'>
            {props.onCriteriaReset ?
                <button
                    className='secondary-button'
                    onClick={props.onCriteriaReset}
                    type='submit'
                >
                    <FormattedMessage id='RESET'/>
                </button> :
                null
            }
            {props.showReport ?
                <button
                    className='primary-button'
                    disabled={!props.canRunReport}
                    onClick={props.onRunReport}
                    type='button'
                >
                    <FormattedMessage id='EXECUTE'/>
                </button> :
                null
            }
        </div>
    </section>;

ReportCriteriaFooter.displayName = 'ReportCriteriaFooter';
ReportCriteriaFooter.propTypes = {
    canRunReport: PropTypes.bool,
    isRequired: PropTypes.bool.isRequired,
    onCriteriaReset: PropTypes.func,
    onRunReport: PropTypes.func.isRequired,
    showReport: PropTypes.bool.isRequired
};

export default ReportCriteriaFooter;



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-criteria-footer/index.js